var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from "react";
import { StepType } from "@types";
import { appendSchema, findMultipleSourcesByIds, getQueryUntilPreviousStep, getSchemaForSource, getSchemaForStep, getSelectedStepDetailsById, isDataSource, isSourceAvailableInQuery, registerStep, validateSourceById, validateStep, validateStepNameAndId } from "@utils";
import { FormSection } from "@components/FormSection/FormSection";
import { MultipleSourcesSelectorInput } from "../SourceSelector/SourceSelectorInput";
import Icon from '@images/union.svg';
import { updateStep } from "../StepConfigUtils";
export function renderStep(context, query, onChange, selectedStepId) {
    const { step, index, previousSteps, selectedSources } = getSelectedStepDetailsById(query, selectedStepId);
    const _step = Object.assign({}, step);
    const $L = (key) => context.uxpContext.$L(key);
    const [errors, setErrors] = useState({});
    useEffect(() => {
        const { isValid, errors } = validateStep(query, step);
        const resolved = Object.fromEntries(Object.entries(errors || {}).map(([k, v]) => [k, v && v.startsWith('lqe.') ? $L(v) : v]));
        setErrors(resolved);
    }, [step]);
    const sources = findMultipleSourcesByIds(query, _step.sources);
    function updateValue(updated) {
        return __awaiter(this, void 0, void 0, function* () {
            let _query = Object.assign({}, query);
            for (const source of updated) {
                if (isDataSource(source) && !isSourceAvailableInQuery(_query, source.id)) {
                    _query.sources.push(source);
                }
                //since current step is not configured properly get query up to previous step to get the schema
                const tempQuery = getQueryUntilPreviousStep(_query, selectedStepId);
                const schema = yield (isDataSource(source) ? getSchemaForSource : getSchemaForStep)(context, tempQuery, source.id);
                _query = appendSchema(_query, schema, source.id, true);
            }
            const _updQuery = updateStep(_query, selectedStepId, 'sources', [...updated.map(s => s.id)]);
            onChange(_updQuery);
        });
    }
    return React.createElement(React.Fragment, null,
        React.createElement(FormSection, { label: $L('lqe.step.union.sources'), error: errors === null || errors === void 0 ? void 0 : errors.sources },
            React.createElement(MultipleSourcesSelectorInput, { sources: sources, onChange: updated => {
                    updateValue(updated);
                }, availableSources: [...previousSteps, ...selectedSources], query: query })));
}
function validate(query, step) {
    var _a;
    const errors = validateStepNameAndId(step);
    // validate sources
    if (!(step === null || step === void 0 ? void 0 : step.sources) || ((_a = step === null || step === void 0 ? void 0 : step.sources) === null || _a === void 0 ? void 0 : _a.length) == 0)
        errors.sources = 'lqe.step.union.error-no-source';
    else {
        const allSourceValid = step.sources.every(sourceId => validateSourceById(query, sourceId).isValid);
        if (!allSourceValid)
            errors.sources = 'lqe.step.union.error-invalid-source';
        else {
            const uniqueSources = new Set(step.sources);
            if (uniqueSources.size !== step.sources.length) {
                errors.sources = 'lqe.step.union.error-duplicate';
            }
        }
    }
    return {
        isValid: Object.keys(errors).length === 0,
        errors
    };
}
registerStep({
    type: StepType.Union,
    name: "lqe.step.union.name",
    description: "lqe.step.union.description",
    icon: Icon,
    render: renderStep,
    validate: validate,
    onSelectStep: (basicProps, previousSource) => {
        return Object.assign(Object.assign({}, basicProps), { sources: [previousSource] });
    }
});
